// GoogleAnalyticsTracking 已關掉 gtag 自動 page_view（send_page_view: false）
// 換頁時由 _app 統一呼叫這裡手動送 page_view
export const GA_MEASUREMENT_ID = 'G-WM58T2D95H';

export function trackPageView(params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  const isDev = process.env.NODE_ENV !== 'production';
  const payload = {
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_MEASUREMENT_ID,
    // 只有非正式環境才帶 debug_mode，讓事件進 GA4 DebugView（正式環境不可帶）
    ...(isDev ? { debug_mode: true } : {}),
    ...params,
  };
  // 開發環境印出，方便本機驗證 brand_id 是否帶上（正式環境不印）
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log('[GA] page_view', payload);
  }
  gtag('event', 'page_view', payload);
}
